import { render, staticRenderFns } from "./style_s_4_control.vue?vue&type=template&id=33fb47fd&scoped=true&"
import script from "./style_s_4_control.vue?vue&type=script&lang=js&"
export * from "./style_s_4_control.vue?vue&type=script&lang=js&"
import style0 from "./style_s_4_control.vue?vue&type=style&index=0&id=33fb47fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb47fd",
  null
  
)

export default component.exports